import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {DateTime} from 'luxon';
import {TranslatePipe} from '@brunata-angular/util';
import {InputDateGroupComponent} from '@brunata-angular/ui';
import {StepCardDirective} from '../step-card/step-card.directive';
import {stepLabels} from '../step-card/step-labels.model';

@Component({
    selector: 'app-reading-date-step',
    standalone: true,
    providers: [
        stepLabels(
            'quickexports_export_step_reading_date_title',
            'quickexports_export_step_reading_date_hint',
        ),
    ],
    hostDirectives: [{directive: StepCardDirective, inputs: ['titleKey', 'hintKey']}],
    imports: [ReactiveFormsModule, TranslatePipe, InputDateGroupComponent],
    template: `
        <div class="bg-primary-faint p-3 border" style="max-width: 34rem">
            <app-input-date-group
                [label]="'quickexports_export_option_reading_date' | translate: 'online' : 'export'"
                [required]="true"
                [noBottomMargin]="true"
                [maxDate]="maxDate()"
                [formControl]="control()" />
            <div class="form-text mt-2">
                {{
                    'quickexports_export_option_readings_on_date_hint'
                        | translate: 'online' : 'export'
                }}
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadingDateStepComponent {
    readonly control = input.required<FormControl<DateTime | null>>();
    readonly maxDate = input.required<DateTime>();
}
